import HometownGroupsItem from './HometownGroupsItem';

export default HometownGroupsItem;
